import { makeStyles } from "@mui/styles";
import { COLORS } from "components/v3/Theme/colors";
import { COLOR_CONSTANTS } from "constants/StyleConstants";
import { TYPOGRAPHY_VARIANTS } from "components/v3/Theme/TypographyVariants";
import checkIcon from "assets/icons/Check.svg";
import arrowRightIcon from "assets/icons/arrow-right.svg";
import aboutYouIcon from "assets/icons/about-you.svg";

// Some of these could be moved to styles for their respective
//  question types if this gets too big in here
const SurveyWrapperStyles = makeStyles((theme?: any) => ({
  loadingContainer: {
    height: "50vh"
  },
  pageProgressContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "8px",
    borderRadius: "24px 24px 0 0",
    overflow: "hidden",
    zIndex: 2,
    backgroundColor: COLORS.SECONDARY_LIGHTEST
  },
  pageProgressFade: {
    position: "absolute",
    top: "8px",
    left: 0,
    right: "15px",
    height: "10px",
    background:
      "linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 20%, rgba(255,255,255,0) 100%)",
    zIndex: 1
  },
  pageProgressBar: {
    height: "100%",
    backgroundColor: "transparent",
    "& .MuiLinearProgress-bar": {
      backgroundColor: COLORS.ACCENT3,
      borderRadius: "0"
    }
  },
  surveyContainer: {
    boxSizing: "border-box",
    flex: 1,
    "--background-dim": "#FFF",
    "--primary": "#000",
    marginBottom: "50px !important",

    "& .sd-root-modern__wrapper": {
      marginTop: "10px"
    },

    "& .sd-footer": {
      paddingTop: "50px !important"
    },
    "& .sd-panel__content": {
      paddingTop: "40px"
    },
    "& .sd-container-modern": {
      borderRadius: "24px",
      height: "calc(100vh - 180px)", // Adjust the 120px offset as needed for your layout
      overflowY: "auto",
      position: "relative",
      paddingTop: "20px", // Space for progress bar
      paddingBottom: "20px", // Space at bottom

      "& .sd-title.sd-element__title span": {
        ...TYPOGRAPHY_VARIANTS.body_strong,
        fontWeight: "700 !important"
      },
      "& .sd-element__header::after": {
        width: "100%",
        background: "#CCCCCC",
        insetInlineStart: "auto"
      },
      "& .gl-question-root h4": {
        margin: "0 0 10px 0",
        ...TYPOGRAPHY_VARIANTS.body_lg1_primary
      },
      "& .sd-panel__title span": {
        ...TYPOGRAPHY_VARIANTS.body_strong,
        fontWeight: "700 !important",
        color: `${COLORS.PRIMARY} !important`,
        fontSize: "32px !important"
      },

      "& .about-you-icon": {
        width: "130px",
        height: "130px",
        backgroundImage: `url(${aboutYouIcon})`,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "left",
        margin: "0 0 30px 0",
        display: "block"
      },

      "& .no-margin": {
        margin: "5px 0 5px 0"
      },

      "& .sd-body": {
        maxWidth: "none",
        overflowX: "hidden",
        padding: "0px",
        "@media (max-width: 400px)": {
          padding: "0px 12px 0 8px"
        }
      },
      // Custom scrollbar styling to avoid progress bar overlap
      "&::-webkit-scrollbar": {
        width: "8px"
      },
      "&::-webkit-scrollbar-track": {
        background: "transparent",
        marginTop: "15px", // Space for progress bar
        marginBottom: "20px" // Space at bottom
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#ccc",
        borderRadius: "4px"
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "#999"
      },
      "& h2": {
        color: COLORS.BLACK,
        fontFamily: "Inter, sans-serif",
        fontSize: "20px",
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "125%",
        letterSpacing: "-0.5px"
      },
      "& h3": {
        color: COLORS.PRIMARY,
        fontFamily: "Inter, sans-serif",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "150%",
        marginBottom: "5px",
        marginTop: "22px"
      },
      "& i": {
        color: COLORS.DARK_GRAY,
        fontFamily: "Inter, sans-serif",
        fontSize: "14px",
        fontStyle: "italic",
        fontWeight: 600,
        lineHeight: "125%"
      },
      "& ul": {
        color: "#000",
        fontFamily: "Inter, sans-serif",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "150%",
        paddingLeft: "24px",
        marginTop: "0px",
        marginBottom: "0px"
      },
      "& .small": {
        color: COLORS.DARK_GRAY,
        fontFamily: "Inter, sans-serif",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "1.2",
        marginTop: "5px"
      },
      "& .strong": {
        fontWeight: 600
      },
      "& .close": {
        marginTop: "-12px"
      },
      "& .distant": {
        marginTop: "20px"
      },
      "& a": {
        fontWeight: 600,
        textDecoration: "none"
      }
    },
    "& .sd-root-modern": {
      borderRadius: "10px",
      "& .sd-navigation__next-btn, .sd-navigation__complete-btn": {
        alignItems: "center",
        backgroundColor: COLORS.PRIMARY,
        borderRadius: "8px",
        cursor: "pointer",
        display: "flex",
        gap: "8px",
        justifyContent: "center",
        margin: 0,
        padding: "8px 24px",
        transition: "background-color 0.3s ease, border-radius 0.3s ease",
        textTransform: "none",
        width: "fit-content",
        [theme.breakpoints.down("lg")]: {
          ...TYPOGRAPHY_VARIANTS.body_strong_white
        },
        [theme.breakpoints.up("lg")]: {
          ...TYPOGRAPHY_VARIANTS.body_strong_lg_white
        },
        "&:hover": {
          backgroundColor: COLORS.PRIMARY_DARK,
          borderRadius: "16px 8px 16px 16px"
        },
        "&:disabled": {
          backgroundColor: COLORS.GRAY,
          color: COLORS.DARK_GRAY
        }
      },
      "& .sd-navigation__next-btn": {
        backgroundImage: `url(${arrowRightIcon})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right 15px center",
        backgroundSize: "20px 20px",
        paddingRight: "48px",
        marginLeft: "auto",
        alignSelf: "flex-end"
      },
      "& #sv-nav-next": {
        marginLeft: "auto",
        display: "flex",
        justifyContent: "flex-end"
      },
      "& #sv-nav-next .sv-action__content": {
        display: "flex",
        justifyContent: "flex-end"
      },

      "& .sd-navigation__prev-btn, .sd-navigation__prev-btn:hover": {
        background: "none",
        border: 0,
        boxShadow: "none",
        display: "block",
        padding: 0,
        ...TYPOGRAPHY_VARIANTS.body_strong_accent1_darker
      },
      "& .sv-action, .sv-action__content": {
        width: "fit-content"
      },
      "& #sv-nav-next, #sv-nav-complete": {
        marginLeft: "auto"
      },
      "& .sd-navigation__complete-btn": {
        // Additional complete button styles can be added here if needed
      },
      "& .sd-paneldynamic": {
        "& button:not(.sd-action--negative)": {
          color: COLOR_CONSTANTS.COLOR_SUCCESS
        }
      },
      "& [data-key*='informed-consent-doc0']": {
        height: "400px",
        overflowY: "scroll",
        border: "1px solid #ccc",
        borderRadius: "5px",
        padding: "20px",
        "& .button": {
          backgroundColor: "#336AB3",
          color: "white",
          textDecoration: "none",
          padding: "10px 20px",
          borderRadius: "4px",
          whiteSpace: "nowrap"
        }
      },
      "& .gl-radio-option-grid": {
        margin: "0 auto",
        padding: "16px 0",
        "& .gl-radio-option-grid-container": {
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: "16px",
          width: "100%",
          boxSizing: "border-box",
          "@media (max-width: 768px)": {
            gridTemplateColumns: "repeat(2, 1fr)"
          }
        },
        "& .gl-radio-option-card": {
          cursor: "pointer",
          borderRadius: "12px",
          backgroundColor: "#F2F7FB",
          border: "3px solid transparent",
          transition: "all 0.15s ease",
          minHeight: "140px",
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          "&:hover": {
            borderRadius: "10px",
            border: "3px solid #7DB7E1",
            backgroundColor: "#F2F7FB",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
          },
          "&.gl-radio-option-card--selected": {
            borderColor: COLORS.PRIMARY,
            backgroundColor: "#E6F3FF",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)"
          }
        },
        "& .gl-radio-option-card-content": {
          padding: "20px",
          textAlign: "center",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          minWidth: 0,
          boxSizing: "border-box",
          overflow: "visible"
        },
        "& .gl-radio-option-icon": {
          width: "48px",
          height: "48px",
          borderRadius: "8px",
          marginBottom: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          fontSize: "20px",
          fontWeight: "bold"
        },
        "& .gl-radio-option-title": {
          ...TYPOGRAPHY_VARIANTS.body_strong,
          fontWeight: 700,
          color: COLORS.BLACK,
          marginBottom: "12px",
          margin: "0 0 8px 0",
          wordWrap: "break-word",
          overflowWrap: "break-word",
          hyphens: "auto",
          minWidth: 0,
          width: "100%",
          textAlign: "center"
        },
        "& .gl-radio-option-description": {
          ...TYPOGRAPHY_VARIANTS.body_sm,
          color: COLORS.DARK_GRAY,
          lineHeight: "1.4",
          margin: 0,
          wordWrap: "break-word",
          overflowWrap: "break-word",
          hyphens: "auto",
          minWidth: 0,
          width: "100%",
          textAlign: "center",
          whiteSpace: "normal",
          overflow: "visible"
        },
        "& .gl-radio-option-grid-display": {
          "& h4": {
            ...TYPOGRAPHY_VARIANTS.body_strong,
            color: COLORS.BLACK,
            marginBottom: "8px"
          },
          "& p": {
            ...TYPOGRAPHY_VARIANTS.body_sm,
            color: COLORS.DARK_GRAY,
            margin: 0
          }
        }
      }
    },
    "& .gl-blue-card": {
      backgroundColor: COLORS.ACCENT1_LIGHTEST,
      borderRadius: "12px",
      padding: "30px 20px",
      margin: "16px 0",
      boxShadow: "0 1px 4px rgba(0, 0, 0, 0.05)",
      maxWidth: "550px",
      "& p": {
        margin: "0 0 12px 0",
        "&:last-child": {
          marginBottom: 0
        }
      },
      "& a": {
        fontWeight: 600,
        textDecoration: "underline !important",
        "&:hover": {
          color: COLORS.ACCENT1_DARKER
        }
      }
    },
    // Boolean button styling
    "& .sd-boolean__thumb-ghost": {
      borderRadius: "4px",
      cursor: "pointer",
      padding: "4px",
      ...TYPOGRAPHY_VARIANTS.body_sm
    },
    "& .sd-boolean--allowhover .sd-boolean__thumb-ghost:hover": {
      backgroundColor: COLORS.ACCENT3_LIGHTEST,
      boxSizing: "border-box",
      textAlign: "center",
      ...TYPOGRAPHY_VARIANTS.body_sm_accent3
    },
    "& .sd-boolean": {
      background: "none",
      boxShadow: "none",
      border: "1px solid",
      borderColor: COLORS.GRAY,
      borderRadius: "4px",
      boxSizing: "border-box",
      padding: "14px",
      "& .sd-boolean__thumb": {
        backgroundColor: COLORS.ACCENT3_LIGHTEST,
        borderRadius: "4px",
        boxShadow: "none",
        boxSizing: "border-box",
        cursor: "pointer",
        padding: "8px",
        textAlign: "center",
        transform: "translateX(10%)",
        width: "40%",
        ...TYPOGRAPHY_VARIANTS.body_strong_sm_accent3_darker
      },
      "& .sd-boolean__label": {
        padding: 0,
        paddingLeft: "20px",
        paddingRight: "20px"
      }
    },
    "& .sd-boolean--checked:not(.sd-boolean--exchanged) .sd-boolean__thumb, .sd-boolean--exchanged:not(.sd-boolean--checked) .sd-boolean__thumb": {
      transform: "translateX(-110%)"
    },
    // Override sd-element--with-frame to remove unwanted drop shadow
    "& .sd-element--with-frame": {
      boxShadow: "none !important",
      border: "none !important",
      padding: "0 5px 0 5px !important"
    },
    // Checkbox styling - ensure white check on black background always
    "& .sd-checkbox": {
      "& .sd-selectbase__label": {
        alignItems: "center"
      },
      "& .sd-item__control-label": {
        ...TYPOGRAPHY_VARIANTS.body_strong
      },
      "&.sd-item, .sd-item__decorator": {
        boxShadow: "none"
        //border: 0
      },
      "&.sd-checkbox--checked": {
        //border: 0
      },
      "& .sd-item__control:focus + .sd-item__decorator": {
        background: "rgba(0,0,0,0)",
        border: "1px solid",
        borderColor: COLORS.SUCCESS
      },
      "& .sd-item__decorator.sd-checkbox__decorator": {
        border: "2px solid #CBD2E0",
        borderRadius: "4px"
      },
      "&.sd-checkbox--checked .sd-item__decorator.sd-checkbox__decorator": {
        backgroundImage: `url(${checkIcon})`,
        background: COLORS.BLACK,
        "--primary-foreground": "rgba(0,0,0,0)",
        backgroundPosition: "center center"
      },
      "& .sd-item__svg.sd-checkbox__svg": {
        display: "none"
      }
    },
    // Slider styling
    "& .sd-slider": {
      "& .sd-slider__label-tick": {
        display: "none"
      },
      "& .sd-slider__track": {
        height: "8px",
        "&:after, &:before": {
          height: "8px"
        },
        "&:before": {
          backgroundColor: COLOR_CONSTANTS.COLOR_INFO
        }
      },
      "& .sd-slider__range-track": {
        backgroundColor: COLOR_CONSTANTS.COLOR_INFO
      },
      "& .sd-slider__thumb-container": {
        top: "2px"
      },
      "& .sd-slider__thumb": {
        backgroundColor: COLOR_CONSTANTS.COLOR_INFO
      },
      "& .sd-slider__thumb-dot": {
        backgroundColor: COLOR_CONSTANTS.COLOR_INFO
      },
      "& .sd-slider-labels-container": {
        //margin: "0"
      },
      // Make all labels smaller at narrow widths
      "& .sd-slider__label .sd-slider__label-text": {
        "@media (max-width: 520px)": {
          fontSize: "12px !important"
        }
      }
    },
    // Radio group styling - match checkbox styling exactly
    "& .sd-radio": {
      "& .sd-selectbase__label": {
        alignItems: "center"
      },
      "& .sd-item__control-label": {
        ...TYPOGRAPHY_VARIANTS.body_strong
      },
      "&.sd-item, .sd-item__decorator": {
        boxShadow: "none"
      },
      "&.sd-radio--checked": {
        //border: 0
      },
      "& .sd-item__control:focus + .sd-item__decorator": {
        background: "rgba(0,0,0,0)",
        border: "1px solid",
        borderColor: COLORS.SUCCESS
      },
      "& .sd-item__decorator.sd-radio__decorator": {
        border: "2px solid #CBD2E0",
        borderRadius: "4px",
        "&:after": {
          display: "none"
        }
      },
      "&.sd-radio--checked .sd-item__decorator.sd-radio__decorator": {
        backgroundImage: `url(${checkIcon})`,
        background: COLORS.BLACK,
        "--primary-foreground": "rgba(0,0,0,0)",
        backgroundPosition: "center center"
      },
      "& .sd-item__svg.sd-radio__svg": {
        display: "none"
      }
    },
    "& #informed-consent-survey": {
      "& .sd-container-modern": {
        height: "100%"
      }
    }
  },
  formTemplateContainer: {
    minHeight: "400px",
    marginBottom: "0px !important",
    "& .sd-container-modern": {
      minHeight: "400px",
      height: "auto",
      overflowY: "visible",
      padding: "0 0 10px 0"
    },
    "& .sd-panel__content": {
      padding: "0"
    },
    "& .sd-page, & .sd-body": {
      padding: "0px  ! important"
    },
    "& h1": {
      fontSize: "24px",
      lineHeight: "28px",
      margin: "0"
    },
    "& h3": {
      fontSize: "20px !important",
      lineHeight: "24px",
      color: `${COLORS.BLACK} !important`,
      margin: "0 !important"
    },
    "& h4": {
      fontSize: "15px",
      lineHeight: "19px",
      margin: "0"
    },
    "& .terms-scrollable-panel": {
      border: "none",
      borderRadius: "0",
      padding: "0 2px",
      overflow: "visible !important",
      height: "auto !important",
      maxHeight: "510px !important",
      "& .sd-panel": {
        padding: "0 10px !important"
      }
    },
    "& .terms-scrollable-panel__content": {},
    "& .sd-error": {
      width: "100%",
      margin: "0",
      borderRadius: "0"
    },
    "& .terms-checkbox-with-button .MuiBox-root": {
      margin: "20px 0"
    }
  }
}));

export default SurveyWrapperStyles;
